import { FormGroup } from '@angular/forms';

export class FormUtil {
  public static validate(form: FormGroup, control: string): { [key: string]: boolean } {
    return {
      'is-invalid': (form.get(control) as any).invalid && ((form.get(control) as any).dirty || (form.get(control) as any).touched)
    };
  }
}
